import { addPassiveEventListener as J, buildSvg as oe } from "./dom-utils.js";
import { KeyCodes as bt } from "./key-codes.js";
export function createCloseButton(t, o, e) {
  var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "ltr";
  var r = document.createElement("button");
  r.setAttribute("aria-label", t), r.setAttribute("tabindex", "0"), r.setAttribute("role", "button"), r.dir = n, J(r, "touchstart"), r.className = "ab-close-button";
  var l = oe("0 0 15 15", "M15 1.5L13.5 0l-6 6-6-6L0 1.5l6 6-6 6L1.5 15l6-6 6 6 1.5-1.5-6-6 6-6z", o);
  return r.appendChild(l), r.addEventListener("keydown", function (t) {
    t.keyCode !== bt.To && t.keyCode !== bt._o || (e(), t.stopPropagation());
  }), r.onclick = function (t) {
    e(), t.stopPropagation();
  }, r;
}